import React, { Component } from "react";
import { Modal, Upload, Button, message, Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { assistant } from "../../utils/axios/assistant";

const { Dragger } = Upload;

class ModalAttachment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      file: null,
      caption: "",
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("paste", this.handlePaste);
  }

  componentWillUnmount() {
    window.removeEventListener("paste", this.handlePaste);
  }

  handleOk = async () => {
    const { file, caption } = this.state;
    if (!file) {
      message.warning("Por favor, selecciona un archivo antes de continuar.");
      return;
    }
    this.setState({ confirmLoading: true });
    const convertFileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
      });
    };
    try {
      const base64File = await convertFileToBase64(file);
      await assistant.post(`/send-message`, {
        client_phone: this.props.selectedClient.contact.phone,
        conversation_id: this.props.selectedClient.id,
        employee_id: this.props.employee_id,
        message: {
          type: this.props.type,
          caption: caption,
          data: {
            file: base64File,
            name: file.name,
          },
        },
      });
      message.success("Archivo enviado con éxito.");
      this.setState({ file: null, caption: "" });
      this.props.handleToggleModalAttachment(false, "");
    } catch (error) {
      console.error(error);
      message.error("Ha ocurrido un error al mandar el archivo.");
    } finally {
      this.setState({ confirmLoading: false });
    }
  };

  handleCancel = () => {
    this.setState({ file: null, caption: "" });
    this.props.handleToggleModalAttachment(false, "");
  };

  handleFileChange = (file) => {
    this.setState({ file });
  };

  handleInputChange = (e) => {
    this.setState({ caption: e.target.value });
  };

  translateToSpanish = (option) => {
    switch (option) {
      case "file":
        return "documento";
      case "photo":
        return "imagen";
      case "text":
        return "texto";
      case "location":
        return "ubicación";
      case "video":
        return "video";
      case "audio":
        return "audio";
      default:
        return "opción no reconocida";
    }
  };

  handlePaste = (event) => {
    if (this.props.type !== "photo") return;
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const file = items[i].getAsFile();
        if (file) {
          this.setState({ file });
          message.success("Imagen pegada desde el portapapeles.");
        }
      }
    }
  };

  render() {
    const { openModal, selectedClient, type } = this.props;
    const { confirmLoading, file, caption } = this.state;

    return (
      <Modal
        title={
          "Adjuntando " +
          this.translateToSpanish(type) +
          " al cliente " +
          (selectedClient && selectedClient.chat_owner
            ? (selectedClient.contact.name ? selectedClient.contact.name : "+" + selectedClient.contact.phone)
            : "sin información")
        }
        open={openModal}
        onOk={this.handleOk}
        centered={true}
        confirmLoading={confirmLoading}
        onCancel={this.handleCancel}
      >
        <Input
          value={caption}
          onChange={this.handleInputChange}
          placeholder="Añade un comentario"
        />
        {type === "photo" && (
          <div className="attachmentSelect">
            <Dragger
              accept=".jpeg,.jpg,.png"
              showUploadList={file ? [{ name: file.name }] : false}
              beforeUpload={(file) => {
                this.handleFileChange(file);
                return false;
              }}
              fileList={file ? [file] : []}
              onRemove={() => {
                this.setState({ file: null });
                message.info("Archivo eliminado");
              }}
              style={{ width: "100%" }}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Haz clic o arrastra una imagen aquí<br />
                <span style={{ color: "#888" }}>
                  (También puedes pegar una imagen desde el portapapeles)
                </span>
              </p>
            </Dragger>
          </div>
        )}
        {type === "file" && (
          <div className="attachmentSelect">
            <Dragger
              accept=".pdf"
              beforeUpload={(file) => {
                this.handleFileChange(file);
                return false;
              }}
              fileList={file ? [file] : []}
              onRemove={() => {
                this.setState({ file: null });
                message.info("Archivo eliminado");
              }}
              style={{ width: "100%" }}

            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">Haz clic o arrastra un documento PDF aquí</p>
            </Dragger>
          </div>
        )}
      </Modal>
    );
  }
}

export default ModalAttachment;



// WEBPACK FOOTER //
// ./src/views/NaduChat/ModalAttachment.jsx